import React from 'react';
import { AppNavPaths } from '../AppNavPaths';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faInfoCircle,
    faLeftLong,
    faSave,
} from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { isTimesheetValid } from './CrewTimesheetValidator';
import { Can } from '../Can';
import _ from 'lodash-es';
import { TimesheetStatus } from '../timesheet/Timesheet';
import ArcGisLocationDisplay from '../lowboyDispatch/ArcGisLocationDisplay';

export default class JobDetailHeader extends React.Component {
    render() {
        const {
            loading,
            timesheet,
            onSaveClick,
            onSubmitClick,
            originalTimesheet,
            job,
            arcGisLocation,
            isReadOnly,
        } = this.props;

        const isValid = isTimesheetValid(timesheet, job);

        if (loading || !timesheet) {
            return null;
        }

        const contract = job.contract;

        const timesheetIsUnchanged = _.isEqual(timesheet, originalTimesheet);

        return (
            <div className="d-flex">
                <div className="align-content-center grid-col">
                    <Can I="accept" a="timesheet">
                        <a
                            href={AppNavPaths.TimesheetManagement}
                            className="text-success"
                        >
                            <FontAwesomeIcon
                                icon={faLeftLong}
                                className="mr-2"
                            />
                            Back to Timesheet Management
                        </a>
                    </Can>

                    <Can not I="accept" a="timesheet">
                        <a
                            href={AppNavPaths.AssignmentCalendar}
                            className="text-success"
                        >
                            <FontAwesomeIcon
                                icon={faLeftLong}
                                className="mr-2"
                            />
                            Back to Calendar
                        </a>
                    </Can>
                </div>

                <div className="col-6">
                    <div className="h2">
                        {contract.number} - {contract.description}
                    </div>

                    {job.notes && (
                        <div className="subtitle mt-2 mb-2">
                            <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="mr-1"
                            />
                            Notes from the PM:
                            <div>
                                <pre>{job.notes}</pre>
                            </div>
                        </div>
                    )}

                    {arcGisLocation && (
                        <div className="subtitle mb-2">
                            Scheduled Location:
                            <ArcGisLocationDisplay
                                arcGisLocation={arcGisLocation}
                            />
                        </div>
                    )}
                </div>

                <div className="align-content-center col-2">
                    <Button
                        type="button"
                        color="success"
                        outline={timesheetIsUnchanged}
                        disabled={timesheetIsUnchanged}
                        onClick={onSaveClick}
                        hidden={isReadOnly}
                    >
                        <FontAwesomeIcon icon={faSave} /> Save
                    </Button>
                </div>

                <div className="align-content-center col-2">
                    <Button
                        type="button"
                        color="success"
                        outline={!isValid}
                        disabled={
                            !isValid ||
                            (timesheet.timesheetStatusId >=
                                TimesheetStatus.Submitted &&
                                timesheetIsUnchanged)
                        }
                        onClick={onSubmitClick}
                        className="float-right"
                        hidden={isReadOnly}
                    >
                        <FontAwesomeIcon icon={faPaperPlane} /> Submit
                    </Button>
                </div>
            </div>
        );
    }
}
